import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate} from "react-router-dom";
import { isAuthenticated } from "@/auth";

const pages = [
  { name: "Agents", key: "" },
  { name: "Tools", key: "tool" },
  { name: "Knowledge", key: "knowledge" },
  { name: "Integrations", key: "integrations" }
];

function samePageLinkNavigation(event) {
  if (
    event.defaultPrevented ||
    event.button !== 0 || // ignore everything but left-click
    event.metaKey ||
    event.ctrlKey ||
    event.altKey ||
    event.shiftKey
  ) {
    return false;
  }
  return true;
}




export default function Header() {
  const [activeNavbar, setActiveNavbar] = useState("automation");
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [anchorElUser, setAnchorElUser] = useState(null);
   const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [value, setValue] = useState(0);
  const navigate = useNavigate()

  const [loggedIn, setLoggedIn] = useState(false);

  // Check authentication status on component mount
  useEffect(() => {
    setLoggedIn(isAuthenticated());
  }, []);


  const handleLogout = () => {
    // Clear token from localStorage
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    // Update authentication state
    setLoggedIn(false);
    if(!isAuthenticated()){
      navigate('/login');
    }
    // Optionally navigate to a different page after logout (e.g., homepage)
  };

  const handleLogin = () => {
    // Navigate to login page
    navigate('/login');
  };

 // Call useLocation unconditionally
let location = useLocation();

// Check if useLocation is available
if (!location) {
  console.error("useLocation must be used within a Router component.");
  location = { pathname: "", state: null, key: "", search: "", hash: "" }; // Fallback with all required properties
}
  const handleChange = (event, newValue) => {
    if (
      event.type !== "click" ||
      (event.type === "click" && samePageLinkNavigation(event))
    ) {
      setValue(newValue);
    }
    setIsMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    if (location.pathname === "/") {
      setValue(0);
    } else if (location.pathname === "/tool"){
      setValue(1);
    }
    else if(location.pathname === "/knowledge") {
      setValue(2);
    }
    else if(location.pathname === "/integrations") {
      setValue(3);
    }
  }, [location]);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };




  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <>
<nav className="bg-white border-gray-200 dark:bg-gray-900">
      <div className="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto p-4">
        <a href="https://flowbite.com/" className="flex items-center space-x-3 rtl:space-x-reverse">
          <img
           src="/img/Logo-Color-new.png" alt="logo" 
            className="h-8"
          />
        </a>
        <button
          onClick={toggleMenu}
          type="button"
          className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
          aria-controls="navbar-default"
          aria-expanded={isMenuOpen}
        >
          <span className="sr-only">Open main menu</span>
          <svg
            className="w-5 h-5"
            aria-hidden="true"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 17 14"
          >
            <path
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M1 1h15M1 7h15M1 13h15"
            />
          </svg>
        </button>
        <div
          className={`w-full md:block md:w-auto ${isMenuOpen ? '' : 'hidden'}`}
          id="navbar-default"
        >
        <ul className="font-medium flex flex-col p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-8 rtl:space-x-reverse md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
  {pages.map((page, ind) => (
    <li key={page.key} className="relative">
      <Link
        to={`/${page.key}`}
        onClick={(e) => handleChange(e, ind)}
        className={`block px-4 py-2 md:px-6 text-lg ${
          value === ind
            ? "after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-full after:h-0.5 after:bg-current"
            : ""
        }`}
      >
        {page.name}
      </Link>
    </li>
  ))}
  
  <li>
    {loggedIn ? (
      <Button className="bg-white hover:bg-gray-100 text-black" onClick={handleLogout}>
        Logout
      </Button>
    ) : (
      <Button className="bg-white hover:bg-gray-100 text-black" onClick={handleLogin}>
        Login
      </Button>
    )}
  </li>
</ul>

        </div>
      </div>
    </nav>
</>
  );
}
